import { BaseLayoutFactory } from '../global/base-layout-factory';
import { NewsDetailProvider } from './context/news-detail-context';
import { NewsDetailComponent } from './news-detail-component';

export function NewsDetailFactory() {
    return (
        <BaseLayoutFactory>
            <NewsDetailProvider>
                <NewsDetailComponent />
            </NewsDetailProvider>
        </BaseLayoutFactory>
    );
}
